// TODO: CONVERT TO TYPESCRIPT
import React from 'react'
import PropTypes from 'prop-types'
import HeaderIcon from 'images/authentication_modals/sign-up.svg'
import InformationIcon from 'images/authentication_modals/information.svg'
import { supplierLandingPath } from '../../routes/path'

function Join (props) {
  return (
    <>
      <div className='modal-top'>
        <img src={HeaderIcon} alt='Icon' className='header-icon' />
        <div className='header pro-head-5' role='heading'>Sign up for full access</div>
        <p className='message'>
          Your free account includes access to all filters, supplier profiles, and vendor performance reviews.
        </p>
        <p className='message'>
          Procurated is exclusively for public sector professionals. Use your work email address to sign up, and our team will grant access once your account is verified.
        </p>
      </div>
      <div className='modal-bottom'>
        <button className='button large expanded join-btn' onClick={props.onSignUp}>Join Procurated</button>

        <div className='sign-in-message join text-center'>
          Already a Procurated member? <a onClick={props.onSignIn} className='sign-in-link'>Sign-in</a>
        </div>

        <div className='grid-x information-container margin-top-3 padding-1'>
          <div className='cell small-2 text-center'>
            <img src={InformationIcon} alt='information' />
          </div>
          <div className='cell small-10'>
            If you are a vendor, <a href={supplierLandingPath()}>visit our supplier page</a> to learn more about Procurated supplier accounts.
          </div>
        </div>
      </div>
    </>
  )
}

Join.propTypes = {
  onSignIn: PropTypes.func.isRequired,
  onSignUp: PropTypes.func.isRequired
}

export default Join
